import React, { useCallback } from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { authConfig } from './config';

interface AppState {
  returnTo?: string;
}

const getSafeReturnTo = (path?: string): string => {
  if (!path) return '/';

  const url = new URL(path, window.location.origin);

  if (url.origin === window.location.origin) {
    return url.pathname + url.search + url.hash;
  }

  return '/';
};

const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const onRedirectCallback = useCallback((appState?: AppState) => {
    const safeReturnTo = getSafeReturnTo(appState?.returnTo);
    window.location.replace(safeReturnTo);
  }, []);

  return (
    <Auth0Provider
      domain={authConfig.domain}
      clientId={authConfig.clientId}
      authorizationParams={{
        scope: authConfig.scope,
        responseType: authConfig.responseType,
        audience: authConfig.audience,
      }}
      onRedirectCallback={onRedirectCallback}
      cacheLocation='localstorage' // Keeps user logged in after refresh
      useRefreshTokens
    >
      {children}
    </Auth0Provider>
  );
};

export default AuthProvider;
